import 'lazysizes';
import 'picturefill';


(($) => {
	$('document').ready(() => {
			
		const $buttonL = $('#button-template-left').clone();
		const $buttonR = $('#button-template-right').clone();
		$('.wp-block-button__link, .XD-btn').each(function () {
			const $this = $(this);
			$(this).html(`${$buttonL.html()}
											<div class="btn-middle">
												<div class="btn-border">
													<span>${$this.html()}</span>
												</div>
											</div>
										${$buttonR.html()}`)
		});
		$('.gform_wrapper input[type="submit"]').each(function () {
			const $this = $(this);
			$(this).before(`
									<a href="#" class="XD-btn">
										${$buttonL.html()}
											<div class="btn-middle">
												<div class="btn-border">
													<span>${$this.attr('value')}</span>
												</div>
											</div>
										${$buttonR.html()}
										</a>`
							)
			$(this).css('visibility', 'hidden');

		});
		$('.gform_wrapper a.XD-btn').on('click', function (e) {
			e.preventDefault();
			$(this).closest('form').trigger('submit', [true]);
		});
	});
})(jQuery);